module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLightItalic.97eb194f.woff";